import { SiteHeader } from '../components/layout/SiteHeader';
import { nl, t } from '../i18n';
import './privacy-page.css';

export default function PrivacyPage() {
  return (
    <div className="page-shell">
      <SiteHeader />
      <div className="privacy-page">
        <h1>{t('privacy.title')}</h1>
        <p className="privacy-intro">{t('privacy.intro')}</p>
        {nl.privacy.body.map((paragraph) => (
          <p key={paragraph}>{paragraph}</p>
        ))}
      </div>
    </div>
  );
}
